(function () {
  'use strict';

  function sendTrack(name, params) {
    if (typeof window.pdpTrack === 'function') {
      window.pdpTrack(name, params);
      return;
    }
    if (typeof window.pdpTrackLater === 'function') {
      window.pdpTrackLater(name, params);
      return;
    }
    console.warn('[pdp-buy-box] Neither window.pdpTrack nor the pdpTrackLater queue exists; dropped event ' + name);
  }

  function initBuyBox(sectionId) {
    var container = document.getElementById('pdp-buybox-' + sectionId);
    if (!container) {
      console.warn('[pdp-buy-box] Container #pdp-buybox-' + sectionId + ' not found');
      return;
    }

    try { initBuyBoxInner(sectionId, container); } catch (e) {
      console.error('[pdp-buy-box] Init failed for section ' + sectionId + ':', e.message, e.stack);
      sendTrack('buybox_error', { code: 'init_failure' });
      container.innerHTML = '<p class="pdp-error-strip" style="margin:16px 0">Error: could not load product data.</p>';
    }
  }

  function initBuyBoxInner(sectionId, container) {

    var variantData, planData, config;
    var currentBlob = '';
    try {
      currentBlob = 'PdpVariantData';
      variantData = JSON.parse(document.getElementById('PdpVariantData-' + sectionId).textContent);
      currentBlob = 'PdpConfig';
      config = JSON.parse(document.getElementById('PdpConfig-' + sectionId).textContent);
      currentBlob = 'PdpPlanData';
      var planEl = document.getElementById('PdpPlanData-' + sectionId);
      planData = planEl ? JSON.parse(planEl.textContent) : [];
    } catch (e) {
      console.error('[pdp-buy-box] Failed to parse ' + currentBlob + '-' + sectionId + ':', e.message);
      showFatalError(container, 'Error: could not load product data.');
      return;
    }

    var moneyFormat = config.moneyFormat || '${{amount}}';

    var state = {
      size: null,
      grind: null,
      purchaseType: config.requiresPlan ? 'subscription' : 'onetime',
      planId: config.defaultPlanId ? String(config.defaultPlanId) : null,
      frequencyWeeks: config.defaultFreqWeeks || 4,
      quantity: 1,
      variantId: String(config.initialVariantId),
      available: true
    };

    var urlParams = new URLSearchParams(window.location.search);
    var hasUrlVariant = urlParams.has('variant');

    if (!hasUrlVariant) {
      var smallestOz = Infinity;
      var smallestId = null;
      var ids = Object.keys(variantData);
      for (var si = 0; si < ids.length; si++) {
        var sv = variantData[ids[si]];
        if (!sv.available) continue;
        if (sv.ounces > 0 && sv.ounces < smallestOz) {
          smallestOz = sv.ounces;
          smallestId = ids[si];
        }
      }
      if (smallestId) {
        state.variantId = smallestId;
      }
    }

    var initialVariant = variantData[state.variantId];
    if (initialVariant) {
      container.querySelectorAll('[data-grind-value].is-selected').forEach(function (el) {
        state.grind = el.dataset.grindValue;
      });

      var sizeCards = container.querySelectorAll('[data-size-value].pdp-size__card');
      if (sizeCards.length > 0) {
        var sIdx = parseInt(sizeCards[0].dataset.optionIndex, 10);
        state.size = initialVariant.options[sIdx];
      }

      var grindChips = container.querySelectorAll('[data-grind-value]');
      if (grindChips.length > 0) {
        var gIdx = parseInt(grindChips[0].dataset.optionIndex, 10);
        state.grind = initialVariant.options[gIdx];
      }

      // Single-value options shown as static blocks: take the value from the variant, not from text
      [['[data-pdp-static-size]', 'size'], ['[data-pdp-static-grind]', 'grind']].forEach(function (pair) {
        var staticEl = container.querySelector(pair[0]);
        if (!staticEl || state[pair[1]] !== null) return;
        var staticIdx = parseInt(staticEl.dataset.optionIndex, 10);
        if (isNaN(staticIdx) || initialVariant.options[staticIdx] === undefined) {
          console.warn('[pdp-buy-box] Static ' + pair[1] + ' block has no matching option on variant ' + state.variantId);
          return;
        }
        state[pair[1]] = initialVariant.options[staticIdx];
      });

      state.available = initialVariant.available;
    }

    // --- DOM refs ---
    var priceCurrentEl = document.querySelector('#pdp-price-' + sectionId + ' [data-pdp-price-current]');
    var priceCompareEl = document.querySelector('#pdp-price-' + sectionId + ' [data-pdp-price-compare]');
    var priceSaveEl = document.querySelector('#pdp-price-' + sectionId + ' [data-pdp-price-save]');
    var buttonLabel = container.querySelector('[data-pdp-button-label]');
    var submitBtn = container.querySelector('.pdp-button');
    var variantInput = container.querySelector('input[name="id"]');
    var planInput = container.querySelector('input[name="selling_plan"]');
    var qtyInput = container.querySelector('input[name="quantity"]');
    var qtyLabel = container.querySelector('[data-pdp-qty-label]');
    var qtyWrap = container.querySelector('[data-pdp-quantity]');
    var assuranceEl = container.querySelector('[data-pdp-assurance]');
    var assuranceOnetime = container.querySelector('[data-pdp-assurance-onetime]');
    var assuranceSub = container.querySelector('[data-pdp-assurance-sub]');
    var frequencyEl = container.querySelector('[data-pdp-frequency]');
    var savingsCopy = container.querySelector('[data-pdp-savings-copy]');
    var subPctTag = container.querySelector('[data-pdp-sub-pct-tag]');
    var subPriceEl = container.querySelector('[data-pdp-sub-price]');
    var subPriceNowEl = container.querySelector('[data-pdp-sub-price-now]');
    var subPriceWasEl = container.querySelector('[data-pdp-sub-price-was]');
    var errorStrip = document.getElementById('pdp-error-' + sectionId);
    var form = container.querySelector('form');

    // --- Free-shipping bar ---
    var shippingBarEl = document.getElementById('pdp-shipping-bar-' + sectionId);
    var shippingTextEl = shippingBarEl ? shippingBarEl.querySelector('[data-pdp-shipping-text]') : null;
    var shippingTrackEl = shippingBarEl ? shippingBarEl.querySelector('[data-pdp-shipping-track]') : null;
    var shippingFillEl = shippingBarEl ? shippingBarEl.querySelector('[data-pdp-shipping-fill]:not([data-pdp-shipping-fill-projected])') : null;
    var shippingFillProjectedEl = shippingBarEl ? shippingBarEl.querySelector('[data-pdp-shipping-fill-projected]') : null;
    var freeShippingThreshold = config.freeShippingThreshold || 0;
    var gapCutoff = (config.gapCutoff || 20) * 100;
    var productId = config.productId || 0;
    var cartSubtotal = 0;
    var cartHasSubscription = false;
    var variantInCart = false;
    var cartLoaded = false;
    var lastShippingState = 0;

    function fetchCart() {
      if (config.showFreeShippingBar === false) return;
      // A sold-out product with one variant is rendered without the bar on purpose, so that is not a problem to report.
      if (!shippingBarEl && !state.available) return;
      if (!shippingBarEl || !shippingTextEl || !freeShippingThreshold) {
        console.warn('[pdp-buy-box] fetchCart skipped: shippingBarEl=' + !!shippingBarEl + ' shippingTextEl=' + !!shippingTextEl + ' threshold=' + freeShippingThreshold);
        return;
      }
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          cartLoaded = true;
          cartSubtotal = cart.total_price || 0;
          cartHasSubscription = false;
          variantInCart = false;
          var currentPlanId = state.purchaseType === 'subscription' && state.planId ? String(state.planId) : '';
          for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            if (item.selling_plan_allocation) {
              cartHasSubscription = true;
            }
            if (String(item.variant_id) === String(state.variantId)) {
              var itemPlanId = item.selling_plan_allocation ? String(item.selling_plan_allocation.selling_plan.id) : '';
              if (itemPlanId === currentPlanId) {
                variantInCart = true;
              }
            }
          }
          updateShippingBar();
        })
        .catch(function (err) {
          console.error('[pdp-buy-box] Failed to fetch cart:', err.message);
        });
    }

    function updateShippingBar() {
      if (config.showFreeShippingBar === false || !state.available) return;
      if (!shippingBarEl || !shippingTextEl || !freeShippingThreshold) {
        console.warn('[pdp-buy-box] updateShippingBar skipped: shippingBarEl=' + !!shippingBarEl + ' shippingTextEl=' + !!shippingTextEl + ' threshold=' + freeShippingThreshold);
        return;
      }
      var currentPrice = getPrice();
      var lineTotal = currentPrice * state.quantity;
      var isSub = state.purchaseType === 'subscription' || cartHasSubscription;
      var stateNum, amountAway, pct, html;

      if (isSub) {
        stateNum = 5;
        html = 'Free shipping on every delivery.';
        pct = 100;
        amountAway = 0;
      } else {
        var projected = variantInCart ? cartSubtotal : cartSubtotal + lineTotal;
        amountAway = freeShippingThreshold - projected;
        pct = projected > 0 ? Math.min(Math.round(projected / freeShippingThreshold * 100), 99) : 0;

        if (projected >= freeShippingThreshold) {
          pct = 100;
          amountAway = 0;
          if (variantInCart) {
            stateNum = 4;
            html = "You've unlocked free shipping.";
          } else {
            stateNum = 2;
            html = "Add to cart and you'll unlock free shipping.";
          }
        } else if (amountAway > gapCutoff) {
          html = 'Free shipping on orders ' + formatMoney(freeShippingThreshold, true) + ' and up.';
          stateNum = variantInCart ? 3 : 1;
        } else {
          var boldAmount = '<strong>' + formatMoney(amountAway) + '</strong>';
          if (variantInCart) {
            stateNum = 3;
            html = "You're only " + boldAmount + " away from free shipping.";
          } else {
            stateNum = 1;
            html = '<span class="pdp-shipping-long">Add to cart and you\'re only ' + boldAmount + ' away from free shipping.</span>'
              + '<span class="pdp-shipping-short">Add to cart: only ' + boldAmount + ' from free shipping.</span>';
          }
        }
      }

      shippingTextEl.innerHTML = html;
      var showBar = stateNum === 1 || stateNum === 3;

      var cartPct = 0;
      var projectedPct = 0;
      if (showBar) {
        cartPct = cartSubtotal > 0 ? Math.min(Math.round(cartSubtotal / freeShippingThreshold * 100), 99) : 0;
        if (variantInCart) {
          projectedPct = 0;
        } else {
          projectedPct = pct - cartPct;
          if (projectedPct < 0) projectedPct = 0;
        }
        if (pct >= 100) {
          cartPct = variantInCart ? 100 : Math.round(cartSubtotal / freeShippingThreshold * 100);
          projectedPct = variantInCart ? 0 : 100 - cartPct;
        }
      }

      if (shippingTrackEl) {
        var projectedDollars = Math.min(variantInCart ? cartSubtotal : cartSubtotal + lineTotal, freeShippingThreshold);
        var thresholdDollars = freeShippingThreshold;
        shippingTrackEl.setAttribute('aria-valuenow', (projectedDollars / 100).toFixed(2));
        shippingTrackEl.setAttribute('aria-valuetext', formatMoney(projectedDollars) + ' of ' + formatMoney(thresholdDollars) + ' toward free shipping');
        shippingTrackEl.hidden = !showBar;
        if (pct >= 100) {
          shippingTrackEl.setAttribute('data-full', '');
        } else {
          shippingTrackEl.removeAttribute('data-full');
        }
      }
      if (shippingFillEl) {
        shippingFillEl.style.width = cartPct + '%';
        if (projectedPct > 0) {
          shippingFillEl.removeAttribute('data-endcap');
        } else if (cartPct > 0) {
          shippingFillEl.setAttribute('data-endcap', '');
        } else {
          shippingFillEl.removeAttribute('data-endcap');
        }
      }
      if (shippingFillProjectedEl) {
        shippingFillProjectedEl.style.width = projectedPct + '%';
        if (projectedPct > 0) {
          shippingFillProjectedEl.setAttribute('data-endcap', '');
        } else {
          shippingFillProjectedEl.removeAttribute('data-endcap');
        }
      }
      shippingBarEl.hidden = false;

      if (cartLoaded && stateNum !== lastShippingState) {
        lastShippingState = stateNum;
        var trackedState = stateNum === 5 ? 'unlocked_subscription' : (stateNum === 2 || stateNum === 4 ? 'unlocked_cart' : 'progress');
        fireGa4('free_shipping_bar_state', { state: trackedState, amount_away: Math.max(0, amountAway) / 100 });
      }
    }

    // --- Helpers ---

    // dropWholeCents: show "$35" instead of "$35.00" when the amount is a whole number of dollars.
    function formatMoney(cents, dropWholeCents) {
      var amount = (cents / 100).toFixed(2);
      var amountNoDecimals = Math.round(cents / 100).toString();
      var format = moneyFormat;
      if (dropWholeCents && cents % 100 === 0) {
        format = format
          .replace('{{amount}}', '{{amount_no_decimals}}')
          .replace('{{amount_with_comma_separator}}', '{{amount_no_decimals_with_comma_separator}}');
      }
      return format
        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals)
        .replace('{{amount_no_decimals}}', amountNoDecimals)
        .replace('{{amount}}', amount);
    }

    function resolveVariant() {
      var ids = Object.keys(variantData);
      for (var i = 0; i < ids.length; i++) {
        var v = variantData[ids[i]];
        var match = true;
        if (state.size !== null) {
          var sizeCards = container.querySelectorAll('[data-size-value].pdp-size__card');
          if (sizeCards.length > 0) {
            var sIdx = parseInt(sizeCards[0].dataset.optionIndex, 10);
            if (v.options[sIdx] !== state.size) match = false;
          }
        }
        if (state.grind !== null && match) {
          var grindChips = container.querySelectorAll('[data-grind-value]');
          if (grindChips.length > 0) {
            var gIdx = parseInt(grindChips[0].dataset.optionIndex, 10);
            if (v.options[gIdx] !== state.grind) match = false;
          }
        }
        if (match) {
          state.variantId = ids[i];
          state.available = v.available;
          return;
        }
      }
      state.available = false;
    }

    function getVariant() {
      return variantData[state.variantId];
    }

    function getPrice() {
      var v = getVariant();
      if (!v) return 0;
      if (state.purchaseType === 'subscription' && state.planId && v.plans[state.planId] !== undefined) {
        return v.plans[state.planId];
      }
      return v.price;
    }

    function getOnetimePrice() {
      var v = getVariant();
      return v ? v.price : 0;
    }

    // --- Stock limits and sold-out cards ---

    // Only a variant that tracks inventory with the deny policy has a hard cap; coffee has none.
    function getMaxQty() {
      var v = getVariant();
      if (!v || v.inventoryManagement !== 'shopify' || v.inventoryPolicy !== 'deny') return null;
      return Math.max(0, parseInt(v.inventoryQuantity, 10) || 0);
    }

    function announceLimit(max) {
      if (liveRegion) liveRegion.textContent = 'Only ' + max + ' available.';
    }

    function applyStockLimit() {
      var maxQty = getMaxQty();
      var plusBtn = container.querySelector('[data-pdp-qty-plus]');
      var note = container.querySelector('[data-pdp-qty-note]');
      if (!qtyInput) return;
      if (maxQty === null) {
        qtyInput.removeAttribute('max');
      } else {
        qtyInput.max = String(Math.max(1, maxQty));
        if (maxQty >= 1 && state.quantity > maxQty) {
          state.quantity = maxQty;
          qtyInput.value = String(maxQty);
        }
      }
      var atCap = maxQty !== null && maxQty >= 1 && state.quantity >= maxQty;
      if (plusBtn) {
        if (atCap) plusBtn.setAttribute('aria-disabled', 'true');
        else plusBtn.removeAttribute('aria-disabled');
      }
      if (note) {
        if (atCap) {
          note.textContent = 'Only ' + maxQty + ' available.';
          note.hidden = false;
          qtyInput.setAttribute('aria-describedby', note.id);
        } else {
          note.hidden = true;
          note.textContent = '';
          qtyInput.removeAttribute('aria-describedby');
        }
      }
    }

    // A card is sold out when no variant with that value (and the other option's current choice) is available.
    function optionValueAvailable(optionIndex, value) {
      var sizeCards = container.querySelectorAll('[data-size-value].pdp-size__card');
      var grindChips = container.querySelectorAll('[data-grind-value]');
      var sIdx = sizeCards.length > 0 ? parseInt(sizeCards[0].dataset.optionIndex, 10) : -1;
      var gIdx = grindChips.length > 0 ? parseInt(grindChips[0].dataset.optionIndex, 10) : -1;
      var ids = Object.keys(variantData);
      for (var i = 0; i < ids.length; i++) {
        var v = variantData[ids[i]];
        if (v.options[optionIndex] !== value) continue;
        if (optionIndex === sIdx && gIdx >= 0 && state.grind !== null && v.options[gIdx] !== state.grind) continue;
        if (optionIndex === gIdx && sIdx >= 0 && state.size !== null && v.options[sIdx] !== state.size) continue;
        if (v.available) return true;
      }
      return false;
    }

    function markSoldOut(el, optionIndex, value) {
      var open = optionValueAvailable(optionIndex, value);
      el.classList.toggle('is-soldout', !open);
      if (open) {
        el.removeAttribute('aria-disabled');
        el.removeAttribute('aria-label');
      } else {
        el.setAttribute('aria-disabled', 'true');
        el.setAttribute('aria-label', value + ', sold out');
      }
    }

    var STOCK_FALLBACK = 'That quantity is not available. Please lower it and try again.';
    var STOCK_WORDS = /only add|are in your cart|in stock|not enough|enough|available|sold out|out of stock|quantity/i;

    // The theme passes the readable cart answer as event.errors (a string) and a bare "Cart Error" as message.
    function stockMessage(event) {
      if (getMaxQty() === null) return '';
      var text = typeof event.errors === 'string' ? event.errors.trim() : '';
      if (!STOCK_WORDS.test(text) && !STOCK_WORDS.test(String(event.message || ''))) return '';
      var readable = text.length > 0 && text.length <= 200 && text.indexOf('<') === -1;
      return readable ? text : STOCK_FALLBACK;
    }

    // --- Radio groups (WAI-ARIA radio group pattern) ---
    // Each role="radiogroup" is a single Tab stop (roving tabindex); the arrow keys move focus and select.

    // The radios that belong to this group itself, not to a group nested inside one of its cards.
    function radiosOf(group) {
      return Array.prototype.filter.call(group.querySelectorAll('[role="radio"]'), function (r) {
        return r.closest('[role="radiogroup"]') === group;
      });
    }

    function radioEnabled(r) {
      return r.getAttribute('aria-disabled') !== 'true';
    }

    // The selected card is the tab stop; with none selected it is the first enabled card.
    function syncRadioTabStops() {
      container.querySelectorAll('[role="radiogroup"]').forEach(function (group) {
        var radios = radiosOf(group);
        var stop = null;
        for (var i = 0; i < radios.length && !stop; i++) {
          if (radios[i].getAttribute('aria-checked') === 'true') stop = radios[i];
        }
        for (var j = 0; j < radios.length && !stop; j++) {
          if (radioEnabled(radios[j])) stop = radios[j];
        }
        if (!stop && radios.length > 0) {
          console.warn('[pdp-buy-box] No card in the "' + group.getAttribute('aria-label') + '" group can take focus; every card is disabled.');
        }
        radios.forEach(function (r) {
          r.setAttribute('tabindex', r === stop ? '0' : '-1');
        });
      });
    }

    function render() {
      var v = getVariant();
      if (!v) return;
      container.setAttribute('data-pdp-available', String(state.available));
      applyStockLimit();
      var currentPrice = getPrice();
      var onetimePrice = getOnetimePrice();

      // Price block — unified for both modes
      if (priceCurrentEl) priceCurrentEl.textContent = formatMoney(currentPrice);
      var comparePrice = 0;
      var titleSavePct = 0;
      if (state.purchaseType === 'subscription' && onetimePrice > currentPrice) {
        comparePrice = onetimePrice;
        titleSavePct = Math.round((onetimePrice - currentPrice) / onetimePrice * 100);
      } else if (v.compareAtPrice && v.compareAtPrice > v.price) {
        // One-time, or a subscription with no plan saving (Roaster's Choice): compare-at only
        comparePrice = v.compareAtPrice;
        titleSavePct = Math.round((v.compareAtPrice - v.price) / v.compareAtPrice * 100);
      }
      if (priceCompareEl) {
        if (comparePrice > 0 && titleSavePct >= 1) {
          priceCompareEl.innerHTML = '<span class="visually-hidden">Compare at </span>' + formatMoney(comparePrice);
          priceCompareEl.hidden = false;
        } else {
          priceCompareEl.hidden = true;
        }
      }
      if (priceSaveEl) {
        if (titleSavePct >= 1) {
          priceSaveEl.textContent = 'SAVE ' + titleSavePct + '%';
          priceSaveEl.hidden = false;
        } else {
          priceSaveEl.hidden = true;
        }
      }

      // Subscribe card savings copy + tag
      if (state.purchaseType === 'subscription' || config.hasPlans) {
        var subPlanPrice = state.planId && v.plans[state.planId] !== undefined ? v.plans[state.planId] : onetimePrice;
        var savingsAmt = onetimePrice - subPlanPrice;
        var savingsPct = onetimePrice > 0 ? Math.round(savingsAmt / onetimePrice * 100) : 0;
        if (savingsCopy) {
          savingsCopy.textContent = savingsAmt > 0 ? 'Save ' + formatMoney(savingsAmt) + ' on every bag.' : '';
        }
        if (subPctTag) {
          subPctTag.textContent = savingsPct > 0 ? savingsPct + '% OFF' : '';
        }
        // Price on the Subscribe card: per bag (not times the quantity), shown only when this variant has a
        // plan price below the one-time price and can be bought.
        if (subPriceEl && subPriceNowEl && subPriceWasEl) {
          var planPriceExists = !!state.planId && v.plans[state.planId] !== undefined;
          var showSubPrice = planPriceExists && savingsAmt > 0 && state.available;
          subPriceEl.hidden = !showSubPrice;
          if (showSubPrice) {
            subPriceNowEl.textContent = formatMoney(subPlanPrice);
            subPriceWasEl.textContent = formatMoney(onetimePrice);
          }
        } else if (subPriceEl) {
          console.warn('[pdp-buy-box] The Subscribe card price block is incomplete (missing now or was price element).');
        }
      }

      // Purchase type cards
      container.querySelectorAll('[data-purchase-type]').forEach(function (card) {
        var isSelected = card.dataset.purchaseType === state.purchaseType;
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-checked', String(isSelected));
      });

      // Frequency cards visibility + selection
      if (frequencyEl) {
        frequencyEl.hidden = state.purchaseType !== 'subscription';
      }
      container.querySelectorAll('[data-plan-id]').forEach(function (card) {
        var isSelected = String(card.dataset.planId) === String(state.planId);
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-checked', String(isSelected));
      });

      // Size cards
      container.querySelectorAll('.pdp-size__card').forEach(function (card) {
        var isSelected = card.dataset.sizeValue === state.size;
        card.classList.toggle('is-selected', isSelected);
        card.setAttribute('aria-checked', String(isSelected));
        markSoldOut(card, parseInt(card.dataset.optionIndex, 10), card.dataset.sizeValue);
      });

      // Grind chips
      container.querySelectorAll('.pdp-grind__chip').forEach(function (chip) {
        var isSelected = chip.dataset.grindValue === state.grind;
        chip.classList.toggle('is-selected', isSelected);
        chip.setAttribute('aria-checked', String(isSelected));
        markSoldOut(chip, parseInt(chip.dataset.optionIndex, 10), chip.dataset.grindValue);
      });

      syncRadioTabStops();

      // Savings tags on size cards
      updateSavingsTags();

      // Quantity
      if (qtyLabel) {
        qtyLabel.textContent = state.purchaseType === 'subscription' ? 'Bags Per Delivery' : 'Quantity';
      }
      if (qtyInput && parseInt(qtyInput.value, 10) !== state.quantity) {
        qtyInput.value = state.quantity;
      }

      // Hidden form inputs
      if (variantInput) {
        variantInput.value = state.variantId;
        variantInput.disabled = !state.available;
      }
      if (planInput) {
        planInput.value = state.purchaseType === 'subscription' && state.planId ? state.planId : '';
      }

      // Button
      if (submitBtn && buttonLabel) {
        if (!state.available) {
          submitBtn.setAttribute('aria-disabled', 'true');
        } else if (!submitBtn.hasAttribute('aria-busy')) {
          submitBtn.removeAttribute('aria-disabled');
        }
        if (!state.available) {
          buttonLabel.textContent = 'Sold out';
        } else if (state.purchaseType === 'subscription') {
          var freqPlan = findPlanById(state.planId);
          var freqLabel = freqPlan
            ? ' every ' + freqPlan.intervalCount + ' ' + freqPlan.intervalUnit + (freqPlan.intervalCount > 1 ? 's' : '')
            : '';
          buttonLabel.textContent = 'Subscribe · ' + formatMoney(currentPrice * state.quantity) + freqLabel;
        } else {
          buttonLabel.textContent = 'Add to cart · ' + formatMoney(currentPrice * state.quantity);
        }
      }

      // Assurance line
      if (assuranceOnetime) assuranceOnetime.hidden = state.purchaseType === 'subscription';
      if (assuranceSub) assuranceSub.hidden = state.purchaseType !== 'subscription';

      // Sold out: hide the quantity stepper, assurance line and free-shipping bar with the hidden attribute
      // (the CSS rule on data-pdp-available is only a backstop). When an available variant is selected again,
      // the stepper and line show again here and updateShippingBar below shows the bar.
      if (qtyWrap) qtyWrap.hidden = !state.available;
      if (assuranceEl) assuranceEl.hidden = !state.available;
      if (shippingBarEl && !state.available) shippingBarEl.hidden = true;

      // Free-shipping bar
      updateShippingBar();

      // URL update
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', state.variantId);
        window.history.replaceState({}, '', url.toString());
      }

      // Notify sticky bar
      var freqPlan = findPlanById(state.planId);
      var freqText = '';
      if (state.purchaseType === 'subscription' && freqPlan) {
        freqText = 'every ' + freqPlan.intervalCount + ' ' + freqPlan.intervalUnit + (freqPlan.intervalCount > 1 ? 's' : '');
      }
      document.dispatchEvent(new CustomEvent('pdp:statechange', {
        detail: {
          sectionId: sectionId,
          price: formatMoney(currentPrice),
          comparePrice: comparePrice > 0 ? formatMoney(comparePrice) : '',
          size: state.size || '',
          frequency: freqText,
          purchaseType: state.purchaseType,
          available: state.available,
          quantity: state.quantity,
          buttonLabel: buttonLabel ? buttonLabel.textContent : ''
        }
      }));
    }

    function updateSavingsTags() {
      var tags = container.querySelectorAll('[data-pdp-savings-tag]');
      if (tags.length === 0) return;

      var sizeCards = container.querySelectorAll('.pdp-size__card');
      if (sizeCards.length === 0) return;
      var sizeOptionIdx = parseInt(sizeCards[0].dataset.optionIndex, 10);

      var smallestOzVariant = null;
      var smallestOz = Infinity;
      sizeCards.forEach(function (card) {
        var sv = findVariantByOption(sizeOptionIdx, card.dataset.sizeValue);
        if (sv && sv.ounces > 0 && sv.ounces < smallestOz) {
          smallestOz = sv.ounces;
          smallestOzVariant = sv;
        }
      });

      if (!smallestOzVariant || smallestOzVariant.ounces <= 0) {
        tags.forEach(function (t) { t.hidden = true; });
        return;
      }
      var basePPO = smallestOzVariant.price / smallestOzVariant.ounces;

      tags.forEach(function (tag) {
        var sizeVal = tag.dataset.sizeValue;
        var v = findVariantByOption(sizeOptionIdx, sizeVal);
        if (!v || v.ounces <= 0 || v === smallestOzVariant) {
          tag.hidden = true;
          return;
        }
        var ppo = v.price / v.ounces;
        var pct = Math.round((1 - ppo / basePPO) * 100);
        if (pct >= 1) {
          tag.textContent = 'SAVE ' + pct + '%';
          tag.hidden = false;
        } else {
          tag.hidden = true;
        }
      });
    }

    function findVariantByOption(optionIndex, value) {
      var ids = Object.keys(variantData);
      for (var i = 0; i < ids.length; i++) {
        var v = variantData[ids[i]];
        if (v.options[optionIndex] !== value) continue;
        var grindChips = container.querySelectorAll('[data-grind-value]');
        if (grindChips.length > 0) {
          var gIdx = parseInt(grindChips[0].dataset.optionIndex, 10);
          if (v.options[gIdx] !== state.grind) continue;
        }
        return v;
      }
      return null;
    }

    function findPlanById(planId) {
      for (var i = 0; i < planData.length; i++) {
        if (String(planData[i].id) === String(planId)) return planData[i];
      }
      return null;
    }

    function warnUnmatchedPlans() {
      var v = getVariant();
      if (!v) return;
      for (var i = 0; i < planData.length; i++) {
        var pid = String(planData[i].id);
        if (v.plans[pid] === undefined) {
          console.warn('[pdp-buy-box] Plan "' + planData[i].name + '" (id=' + pid + ') has no allocation for variant ' + state.variantId);
        }
      }
    }

    // --- Event handlers ---

    container.addEventListener('click', function (e) {
      var target = e.target.closest('[data-plan-id]');
      if (target) {
        var prevPlanId = state.planId;
        state.planId = target.dataset.planId;
        state.frequencyWeeks = parseInt(target.dataset.weeks, 10);
        state.purchaseType = 'subscription';
        render();
        if (state.planId !== prevPlanId) {
          fireGa4('select_frequency', { selling_plan_id: state.planId, frequency_weeks: state.frequencyWeeks });
        }
        return;
      }

      target = e.target.closest('[data-purchase-type]');
      if (target) {
        var prevType = state.purchaseType;
        state.purchaseType = target.dataset.purchaseType;
        if (state.purchaseType === 'subscription' && !state.planId && planData.length > 0) {
          state.planId = String(planData[0].id);
        }
        resolveVariant();
        render();
        if (state.purchaseType !== prevType) {
          fireGa4('select_purchase_type', { purchase_type: purchaseTypeParam() });
        }
        return;
      }

      target = e.target.closest('.pdp-size__card');
      if (target) {
        if (target.getAttribute('aria-disabled') === 'true') return;
        var prevSize = state.size;
        state.size = target.dataset.sizeValue;
        resolveVariant();
        render();
        if (state.size !== prevSize) {
          fireGa4('select_size', { item_variant: String(state.variantId) });
        }
        return;
      }

      target = e.target.closest('.pdp-grind__chip');
      if (target) {
        if (target.getAttribute('aria-disabled') === 'true') return;
        var prevGrind = state.grind;
        state.grind = target.dataset.grindValue;
        resolveVariant();
        render();
        if (state.grind !== prevGrind) {
          fireGa4('select_grind', { grind: state.grind });
        }
        return;
      }

      if (e.target.closest('[data-pdp-qty-minus]')) {
        var val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) {
          state.quantity = val - 1;
          qtyInput.value = state.quantity;
          render();
          trackQuantity();
        }
        return;
      }

      if (e.target.closest('[data-pdp-qty-plus]')) {
        var val2 = parseInt(qtyInput.value, 10) || 1;
        var capPlus = getMaxQty();
        if (capPlus !== null && val2 >= capPlus) {
          announceLimit(capPlus);
          return;
        }
        state.quantity = val2 + 1;
        qtyInput.value = state.quantity;
        render();
        trackQuantity();
        return;
      }
    });

    container.addEventListener('keydown', function (e) {
      var target = e.target.closest('[role="radio"]');
      if (!target) return;

      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        target.click();
        return;
      }

      var step = 0;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') step = 1;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') step = -1;
      var edge = e.key === 'Home' ? 'first' : e.key === 'End' ? 'last' : '';
      if (step === 0 && edge === '') return;

      e.preventDefault();
      var group = target.closest('[role="radiogroup"]');
      if (!group) {
        console.warn('[pdp-buy-box] Arrow key ignored: the card is not inside a radiogroup.');
        return;
      }
      var radios = radiosOf(group);
      var enabled = radios.filter(radioEnabled);
      if (enabled.length === 0) {
        console.warn('[pdp-buy-box] Arrow key ignored: every card in the "' + group.getAttribute('aria-label') + '" group is disabled.');
        return;
      }

      var next = null;
      if (edge === 'first') next = enabled[0];
      else if (edge === 'last') next = enabled[enabled.length - 1];
      else {
        var from = radios.indexOf(target);
        for (var n = 1; n <= radios.length && !next; n++) {
          var cand = radios[(from + step * n + radios.length * n) % radios.length];
          if (radioEnabled(cand)) next = cand;
        }
      }
      if (!next || next === target) {
        console.warn('[pdp-buy-box] Arrow key ignored: no other enabled card in the "' + group.getAttribute('aria-label') + '" group.');
        return;
      }

      // Same path as a click: the click handler updates state, price and form, and fires the GA4 event once.
      next.focus();
      next.click();
    });

    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        var val = parseInt(qtyInput.value, 10);
        var capInput = getMaxQty();
        if (!isNaN(val) && capInput !== null && capInput >= 1 && val > capInput) {
          val = capInput;
          qtyInput.value = String(val);
          announceLimit(capInput);
        }
        if (!isNaN(val) && val >= 1) {
          state.quantity = val;
          render();
        }
      });
      qtyInput.addEventListener('change', function () {
        var val = parseInt(qtyInput.value, 10);
        if (isNaN(val) || val < 1) val = 1;
        var capChange = getMaxQty();
        if (capChange !== null && capChange >= 1 && val > capChange) {
          val = capChange;
          announceLimit(capChange);
        }
        qtyInput.value = val;
        state.quantity = val;
        render();
        trackQuantity();
      });
    } else if (container.querySelector('[data-pdp-quantity]')) {
      console.warn('[pdp-buy-box] Quantity input not found in section ' + sectionId);
    }

    // --- Button states via PubSub ---

    var addedTimer = null;
    var liveRegion = container.querySelector('[data-pdp-live]');
    var cartDidUpdate = false;
    var atcObserver = null;
    var hasCartDrawer = !!document.querySelector('cart-drawer');
    var addSource = 'main';
    var pendingAdd = null;
    var currency = config.currency || '';

    // The sticky bar sets this around its synchronous click on the main button.
    document.addEventListener('pdp:addsource', function (e) {
      if (e.detail && e.detail.sectionId === sectionId) addSource = e.detail.source === 'sticky' ? 'sticky' : 'main';
    });

    if (errorStrip) errorStrip.setAttribute('role', 'alert');

    function setBusy() {
      if (addedTimer) { clearTimeout(addedTimer); addedTimer = null; }
      submitBtn.classList.remove('pdp-button--added', 'pdp-button--failed');
      submitBtn.setAttribute('aria-busy', 'true');
      submitBtn.setAttribute('aria-disabled', 'true');
      buttonLabel.textContent = 'Adding…';
      if (liveRegion) liveRegion.textContent = 'Adding…';
      if (errorStrip) errorStrip.hidden = true;
      document.dispatchEvent(new CustomEvent('pdp:buttonstate', { detail: { sectionId: sectionId, state: 'busy' } }));
    }

    function setAdded() {
      cleanupObserver();
      cartDidUpdate = true;
      submitBtn.removeAttribute('aria-busy');
      submitBtn.removeAttribute('aria-disabled');
      submitBtn.classList.remove('pdp-button--failed');
      if (errorStrip) errorStrip.hidden = true;
      var msg = state.purchaseType === 'subscription' ? 'Subscription added' : 'Added to cart';
      if (liveRegion) liveRegion.textContent = msg;
      if (pendingAdd) {
        fireGa4('buybox_add_to_cart', pendingAdd);
        pendingAdd = null;
      } else {
        console.warn('[pdp-buy-box] Cart updated from product-form with no pending add; buybox_add_to_cart not sent');
      }
      document.dispatchEvent(new CustomEvent('pdp:buttonstate', { detail: { sectionId: sectionId, state: 'added' } }));
      if (hasCartDrawer) {
        render();
        return;
      }
      submitBtn.classList.add('pdp-button--added');
      buttonLabel.textContent = msg;
      addedTimer = setTimeout(function () {
        submitBtn.classList.remove('pdp-button--added');
        if (liveRegion) liveRegion.textContent = '';
        document.dispatchEvent(new CustomEvent('pdp:buttonstate', { detail: { sectionId: sectionId, state: 'normal' } }));
        render();
      }, 2000);
    }

    var NETWORK_ERROR_MSG = "We couldn't add that to your cart. Check your connection and try again.";

    function setFailed(message, quiet) {
      cleanupObserver();
      pendingAdd = null;
      submitBtn.removeAttribute('aria-busy');
      submitBtn.removeAttribute('aria-disabled');
      submitBtn.classList.remove('pdp-button--added');
      submitBtn.classList.add('pdp-button--failed');
      buttonLabel.textContent = 'Try again';
      if (errorStrip && quiet) {
        errorStrip.hidden = true;
      } else if (errorStrip) {
        errorStrip.textContent = 'Error: ' + (message || 'Something went wrong');
        errorStrip.hidden = false;
      }
      if (liveRegion) liveRegion.textContent = 'Error: ' + (message || 'Something went wrong');
      fireErrorEvent('add_to_cart_failure');
      document.dispatchEvent(new CustomEvent('pdp:buttonstate', { detail: { sectionId: sectionId, state: 'failed', message: message } }));
    }

    function cleanupObserver() {
      if (atcObserver) { atcObserver.disconnect(); atcObserver = null; }
    }

    function startObserver() {
      cleanupObserver();
      atcObserver = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'aria-disabled' && !submitBtn.hasAttribute('aria-disabled')) {
            cleanupObserver();
            if (!cartDidUpdate) {
              setFailed(NETWORK_ERROR_MSG);
            }
            return;
          }
        }
      });
      atcObserver.observe(submitBtn, { attributes: true, attributeFilter: ['aria-disabled'] });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (!state.available) {
          e.preventDefault();
          console.warn('[pdp-buy-box] Add to cart ignored: the selected variant is sold out');
          return;
        }
        cartDidUpdate = false;
        if (!navigator.onLine) {
          e.preventDefault();
          setFailed(NETWORK_ERROR_MSG);
          return;
        }
        pendingAdd = {
          item_variant: String(state.variantId),
          purchase_type: purchaseTypeParam(),
          selling_plan_id: state.purchaseType === 'subscription' && state.planId ? String(state.planId) : undefined,
          quantity: state.quantity,
          value: Math.round(getPrice() * state.quantity) / 100,
          currency: currency || undefined,
          source: addSource
        };
        setBusy();
        startObserver();
      });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.source === 'product-form') {
          if (addedTimer) clearTimeout(addedTimer);
          setAdded();
        }
        fetchCart();
      });

      subscribe(PUB_SUB_EVENTS.cartError, function (event) {
        var shownOnFields = giftApi ? giftApi.showCartErrors(event.errors) : false;
        setFailed(stockMessage(event) || event.message, shownOnFields);
      });
    }

    // --- GA4 placeholder ---

    // pdp-tracking.js owns the gtag guard, queueing and ?debug_ga=1 handling.
    function fireGa4(eventName, params) {
      var payload = { item_id: String(productId) };
      Object.keys(params || {}).forEach(function (k) { payload[k] = params[k]; });
      sendTrack(eventName, payload);
    }

    function purchaseTypeParam() {
      return state.purchaseType === 'subscription' ? 'subscription' : 'one_time';
    }

    var lastTrackedQty = state.quantity;
    function trackQuantity() {
      if (state.quantity === lastTrackedQty) return;
      lastTrackedQty = state.quantity;
      fireGa4('change_quantity', { quantity: state.quantity });
    }

    function fireErrorEvent(detail) {
      sendTrack('buybox_error', { code: detail });
    }

    // Still to wire (UI not in this section yet):
    //   size_guide_open { item_id, tab }, gift_options_toggle { form, expanded }, form_error { form, field }
    //   addon_view { item_id, gap_amount }, addon_add / addon_remove { item_id, value }
    //   (add-on moved to the cart drawer after the freeze)

    function showFatalError(el, msg) {
      el.innerHTML = '<p class="pdp-error-strip" style="margin:16px 0">' + msg + '</p>';
      fireErrorEvent('init_failure');
    }

    // --- Gift card recipient fields (snippets/pdp-gift-card-fields.liquid) ---

    var giftApi = null;

    function initGiftForm(root) {
      var formName = root.dataset.formName || 'gift_card';
      var maxMessage = parseInt(root.dataset.maxMessage, 10) || 200;
      var maxDays = parseInt(root.dataset.maxDays, 10) || 90;
      var usesOffset = root.dataset.usesOffset === 'true';
      var productFormEl = container.querySelector('product-form');
      var summary = root.querySelector('[data-pdp-gift-summary]');
      var summaryTitle = root.querySelector('[data-pdp-gift-summary-title]');
      var summaryList = summary ? summary.querySelector('ul') : null;
      var toggle = root.querySelector('[data-pdp-gift-toggle]');
      var extra = root.querySelector('[data-pdp-gift-extra]');
      if (!productFormEl || !summary || !summaryTitle || !summaryList || !toggle || !extra) {
        console.warn('[pdp-buy-box] Gift form not started: missing product-form, error summary, toggle or extra panel');
        return null;
      }

      var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // The field list, rules and messages all come from the data-* attributes in the snippet.
      var KEYS = [];
      var fields = {};
      var fromShopify = {};
      var inputEls = root.querySelectorAll('[data-pdp-gift-field]');
      for (var i = 0; i < inputEls.length; i++) {
        var input = inputEls[i];
        var key = input.dataset.pdpGiftField;
        var errorEl = root.querySelector('[data-pdp-gift-error="' + key + '"]');
        if (!errorEl) {
          console.warn('[pdp-buy-box] Gift form not started: field "' + key + '" has no error strip');
          return null;
        }
        KEYS.push(key);
        fields[key] = {
          input: input,
          errorEl: errorEl,
          label: input.dataset.label || key,
          required: input.dataset.required === 'true',
          ga: input.dataset.gaField || key,
          emptyMessage: input.dataset.empty || '',
          invalidMessage: input.dataset.invalid || '',
          baseDescribedBy: input.getAttribute('aria-describedby') || ''
        };
        if (input.dataset.shopifyKey) fromShopify[input.dataset.shopifyKey] = key;
      }
      if (!fields.message || !fields.date) {
        console.warn('[pdp-buy-box] Gift form not started: the message and send-date fields are missing');
        return null;
      }
      var countEl = root.querySelector('[data-pdp-gift-count]');
      var rangeEl = root.querySelector('[data-pdp-gift-range]');
      var offsetEl = root.querySelector('[data-pdp-gift-offset]');
      var current = [];

      function pad(n) { return n < 10 ? '0' + n : String(n); }
      function iso(d) { return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()); }
      function nice(d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); }

      // The send date runs from today to maxDays ahead (a section setting), in the buyer's own time zone.
      function allowedRange() {
        var min = new Date();
        min.setHours(0, 0, 0, 0);
        var max = new Date(min);
        max.setDate(max.getDate() + maxDays);
        return { min: min, max: max };
      }

      function applyRange() {
        var r = allowedRange();
        fields.date.input.min = iso(r.min);
        fields.date.input.max = iso(r.max);
        if (rangeEl) rangeEl.textContent = 'Choose a date from ' + nice(r.min) + ' to ' + nice(r.max) + '.';
      }

      function check(key) {
        var f = fields[key];
        var el = f.input;
        var v = el.value.trim();
        if (key === 'message') {
          return el.value.length > maxMessage ? 'Keep the message to ' + maxMessage + ' characters or fewer.' : '';
        }
        if (key === 'date') {
          if (el.validity && el.validity.badInput) return 'Enter a complete date.';
          if (!el.value) return '';
          var r = allowedRange();
          return el.value >= iso(r.min) && el.value <= iso(r.max)
            ? ''
            : 'Choose a date from ' + nice(r.min) + ' to ' + nice(r.max) + '.';
        }
        if (f.required && !v) return f.emptyMessage || 'Enter ' + f.label.toLowerCase() + '.';
        if (el.type === 'email' && v && !EMAIL_RE.test(v)) {
          return f.invalidMessage || 'Enter a valid email address, like name@example.com.';
        }
        return '';
      }

      function setOpen(open) {
        toggle.setAttribute('aria-expanded', String(open));
        extra.hidden = !open;
      }

      function inExtra(key) {
        return extra.contains(fields[key].input);
      }

      function showField(key, message) {
        var f = fields[key];
        f.errorEl.textContent = 'Error: ' + message;
        f.errorEl.hidden = false;
        f.input.setAttribute('aria-invalid', 'true');
        f.input.setAttribute('aria-describedby', (f.baseDescribedBy ? f.baseDescribedBy + ' ' : '') + f.errorEl.id);
      }

      function clearField(key) {
        var f = fields[key];
        f.errorEl.hidden = true;
        f.errorEl.textContent = '';
        f.input.removeAttribute('aria-invalid');
        if (f.baseDescribedBy) f.input.setAttribute('aria-describedby', f.baseDescribedBy);
        else f.input.removeAttribute('aria-describedby');
      }

      function renderSummary() {
        while (summaryList.firstChild) summaryList.removeChild(summaryList.firstChild);
        if (!current.length) {
          summary.hidden = true;
          return;
        }
        summaryTitle.textContent = 'Error: ' + current.length + (current.length === 1 ? ' problem' : ' problems') + ' to fix before adding to cart.';
        current.forEach(function (item) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = '#' + fields[item.key].input.id;
          a.textContent = fields[item.key].label + ': ' + item.message;
          a.addEventListener('click', function (e) {
            e.preventDefault();
            if (inExtra(item.key)) setOpen(true);
            fields[item.key].input.focus();
          });
          li.appendChild(a);
          summaryList.appendChild(li);
        });
        summary.hidden = false;
      }

      function showErrors(errors) {
        KEYS.forEach(clearField);
        current = errors.slice();
        current.forEach(function (item) {
          showField(item.key, item.message);
          if (inExtra(item.key)) setOpen(true);
        });
        renderSummary();
        if (current.length) summary.focus();
      }

      function validate() {
        applyRange();
        var errors = [];
        KEYS.forEach(function (key) {
          var message = check(key);
          if (message) errors.push({ key: key, message: message });
        });
        if (!errors.length) {
          KEYS.forEach(function (key) {
            if (key !== 'message' && key !== 'date') fields[key].input.value = fields[key].input.value.trim();
          });
        }
        showErrors(errors);
        errors.forEach(function (item) {
          fireGa4('form_error', { form: formName, field: fields[item.key].ga });
        });
        return errors.length === 0;
      }

      // Shopify's own answer, for example a bad email or a send date out of range (native gift cards only).
      function showCartErrors(errors) {
        if (!errors || typeof errors !== 'object') return false;
        var found = [];
        Object.keys(errors).forEach(function (shopifyKey) {
          var key = fromShopify[shopifyKey];
          if (!key) return;
          var raw = errors[shopifyKey];
          var text = (Array.isArray(raw) ? raw.join(', ') : String(raw)).trim();
          if (!text) return;
          if (/^[a-z]/.test(text)) text = fields[key].label + ' ' + text;
          text = text.charAt(0).toUpperCase() + text.slice(1);
          found.push({ key: key, message: /[.!?]$/.test(text) ? text : text + '.' });
        });
        if (!found.length) return false;
        showErrors(found);
        found.forEach(function (item) {
          fireGa4('form_error', { form: formName, field: fields[item.key].ga });
        });
        return true;
      }

      KEYS.forEach(function (key) {
        fields[key].input.addEventListener('input', function () {
          if (key === 'message' && countEl) countEl.textContent = fields.message.input.value.length + '/' + maxMessage;
          if (fields[key].input.getAttribute('aria-invalid') !== 'true') return;
          if (check(key)) return;
          current = current.filter(function (item) { return item.key !== key; });
          clearField(key);
          renderSummary();
        });
      });

      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        setOpen(open);
        fireGa4('gift_options_toggle', { form: formName, expanded: open });
      });

      // Capture phase on the wrapper runs before the theme's own submit handler on the form,
      // so an invalid form never reaches the cart request (or the Adding… state).
      productFormEl.addEventListener('submit', function (e) {
        if (validate()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
      }, true);

      applyRange();
      // Matches the Recharge widget: today is pre-filled, and a cleared date is still sent (as an empty value).
      if (root.dataset.prefillDate === 'true' && !fields.date.input.value) fields.date.input.value = iso(allowedRange().min);
      if (usesOffset) {
        if (offsetEl) offsetEl.value = String(new Date().getTimezoneOffset());
        else console.warn('[pdp-buy-box] Gift form has no __shopify_offset field; scheduled sends may use the wrong time zone');
      }

      return { validate: validate, showCartErrors: showCartErrors };
    }

    var giftRoot = container.querySelector('[data-pdp-gift-form]');
    if (giftRoot) giftApi = initGiftForm(giftRoot);

    // --- Init ---
    render();
    warnUnmatchedPlans();
    fetchCart();
  }

  // Boot all instances on the page
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function boot() {
    document.querySelectorAll('[data-pdp-section]').forEach(function (el) {
      initBuyBox(el.dataset.pdpSection);
    });
  }
})();
